module.exports = __webpack_public_path__ + "img/bannerlist2.5b1e8e8e.jpg";